<script setup lang="ts">
defineProps<{ confirming: boolean; busy: boolean }>()
defineEmits<{ (e: 'reset'): void; (e: 'cancel'): void }>()
</script>

<template>
  <div class="reset">
    <button type="button" :disabled="busy" @click="$emit('reset')">{{ confirming ? 'Confirm reset?' : 'Reset ceiling' }}</button>
    <button v-if="confirming" type="button" @click="$emit('cancel')">Cancel</button>
  </div>
</template>

<style scoped>
.reset { display: flex; gap: 0.5rem; margin-top: 0.5rem; }
button { min-height: 44px; min-width: 44px; padding: 0 0.8rem; background: #21262d; color: #e6edf3; border: 1px solid #30363d; border-radius: 6px; cursor: pointer; }
button:focus-visible { outline: 2px solid #58a6ff; outline-offset: 2px; }
button:disabled { opacity: 0.5; cursor: default; }
</style>
